/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1yb4%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx2vrvc%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulpu2gc%7Bgap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i8vuz%7Bheight%3A56px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1r62e4h9%7Bborder-block-end-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12ornqa1%7Bborder-block-end-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i5pxbi%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q51pxbi%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1ejb%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1ejb%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1h6d1l7x%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
import React from 'react';
import { useCrossProductUrlWrapper } from '@atlassiansox/analytics-cross-product-interaction-client';
import { useIntl } from 'react-intl';
import { IconButton } from '@atlaskit/button/new';
import ArrowLeft from '@atlaskit/icon/core/arrow-left';
import CrossIcon from '@atlaskit/icon/core/cross';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
import { PanelAction, PanelActionClose, PanelActionGroup, PanelHeader } from '@atlassian/panel-system';
import messages from '../../common/messages';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { PreviewPanelNewTabLink } from '../preview-panel-action-variants/preview-panel-new-tab-link';
import type { PreviewPanelHeaderProps } from './types';

/**
 * Removes the specified query parameter from a URL while preserving all other parameters
 * @param url - The original URL
 * @param paramToRemove - The query parameter name to remove
 * @returns The URL with the specified parameter removed
 */
export const removeQueryParam = (url: string, paramToRemove: string): string => {
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.delete(paramToRemove);
    return urlObj.toString();
  } catch {
    // If URL parsing fails, return the original URL
    return url;
  }
};
const styles = {
  header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
  childWrapper: "_16jlkb7n",
  titleRegion: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _16jlkb7n _1ul9idpf"
};
export const PreviewPanelHeader = ({
  children,
  onClose,
  onOpenInNewTab,
  onNavigateBack,
  testId,
  url,
  analyticsClient,
  parentProduct,
  panelType,
  moreActions
}: PreviewPanelHeaderProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const enableCrossMAUUsage = fg('platform_preview_panels_cross_app_interaction');
  const buildUrlWithAnalyticsParams = useCrossProductUrlWrapper({
    bridge: 'preview-panels',
    product: parentProduct ?? 'unknown'
  });
  const onPanelClose = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'preview-panel-close',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onClose?.();
  };
  const onOpenInNewWindow = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'preview-panel-open-in-new-window',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onOpenInNewTab?.();
    if (url) {
      window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams(removeQueryParam(url, 'previewPanels')) : removeQueryParam(url, 'previewPanels'));
    }
  };
  const onPanelNavigateBack = () => {
    analyticsClient?.sendTrackEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'preview-panel-navigate-back',
      source: 'preview-panel',
      attributes: {
        parentProduct,
        panelType
      }
    });
    onNavigateBack?.();
  };
  if (fg('ads-panel-system-gpp')) {
    return <PanelHeader testId={testId}>
				{onNavigateBack && fg('jivtech-1920-back-navigation-gpp') && <PanelAction icon={ArrowLeft} label={formatMessage(messages.previewPanelNavigateBackLabel)} onClick={onPanelNavigateBack} testId={testId && `${testId}.navigate-back-button`} appearance="default" />}
				<Box xcss={styles.titleRegion}>{children}</Box>
				<PanelActionGroup>
					{url && <PanelAction icon={LinkExternalIcon} label={formatMessage(messages.previewPanelOpenInNewWindowLabel)} onClick={onOpenInNewWindow} testId={testId && `${testId}.open-in-new-window-button`} appearance="subtle" />}
					{moreActions}
					{onClose && <PanelActionClose onClick={onPanelClose} testId={testId && `${testId}.close-button`} label={formatMessage(messages.previewPanelCloseButtonLabel)} />}
				</PanelActionGroup>
			</PanelHeader>;
  }
  return <Inline xcss={styles.header} testId={testId} alignBlock="center" space="space.100">
			{onNavigateBack && fg('jivtech-1920-back-navigation-gpp') && <IconButton icon={iconProps => <ArrowLeft {...iconProps} size="small" />} label={formatMessage(messages.previewPanelNavigateBackLabel)} onClick={onPanelNavigateBack} testId={testId && `${testId}.navigate-back-button`} />}
			<Inline xcss={styles.childWrapper} spread="space-between" alignBlock="center" space="space.100">
				{children}
			</Inline>
			<Flex gap="space.100">
				{url && <PreviewPanelNewTabLink label={formatMessage(messages.previewPanelOpenInNewWindowLabel)} onClick={onOpenInNewWindow} testId={testId && `${testId}.open-in-new-window-button`} />}
				{moreActions}
				{onClose && <IconButton icon={iconProps => <CrossIcon {...iconProps} size="small" />} label={formatMessage(messages.previewPanelCloseButtonLabel)} onClick={onPanelClose} testId={testId && `${testId}.close-button`} role="button" />}
			</Flex>
		</Inline>;
};